import {RootStoreModel} from "@stores/RootStore";

export const clearAllTempState = (rootStore: RootStoreModel) => {
    if (rootStore.view.workspace?.confirmDeleteOpenUnder) {
        rootStore.view.workspace!.setConfirmDeleteOpen(undefined);
    }
}
